import { Input } from '@tiendanube/components';
import { CardWithTitle } from 'commons/components';
import Stack from 'commons/components/Stack';
import useTranslationShipping from 'domains/Shipping/useTranslationShipping';

function Skeleton(): JSX.Element {
  const t = useTranslationShipping();
  return (
    <CardWithTitle
      title={t('oca.config.costAndDays.title')}
      subtitle={t('oca.config.costAndDays.subtitle')}
    >
      <Stack column align="stretch">
        <Input.Skeleton />
        <Input.Skeleton />
      </Stack>
    </CardWithTitle>
  );
}

export default Skeleton;
